export const CREATED = 'CREATED';
export const PIPELINE_STAGE_UPDATED = 'PIPELINE_STAGE_UPDATED';
export const ASSOCIATION_UPDATED = 'ASSOCIATION_UPDATED';